export default text => (
  text ? text.replace(/(?:\r\n|\r|\n)/g, '<br />') : ''
);